{
  "iframeWaitingMessage": "Gracias por esperar. Sólo unos momentos más...",
  "otherOrganizations": "Otras organizaciones",
  "solutionIframe": "Contenido principal",
  "unloadPromptMessage": "¿Está seguro?"
}
